// Deadlines, and the deadlines that do not exist yet.
//
// These were two nav items with the same clock icon: "Deadlines" (what
// is tracked) and "Statute Tracking" (the 161 of 167 open matters
// where no statute is tracked at all). Two rows, one subject — and the
// second is only interesting because of the first.
//
// Together they answer one question with two halves: what is coming
// up, and what is not being watched. Reading the first without the
// second is the dangerous version, because a short list of upcoming
// deadlines looks reassuring exactly when almost nothing is tracked.
//
// The gap count is fetched here rather than left to the tab the user
// might not open, for that reason.

import React, { useEffect, useState } from "react";
import { C } from "../constants.js";
import { apiFetch } from "../api.js";
import { DeadlinesPage } from "./DeadlinesPage.jsx";
import { StatuteGapsPage } from "./StatuteGapsPage.jsx";

export function DeadlinesHubPage({ onMatterClick, showNotification,
                                  initialView = "upcoming" }) {
  const [view, setView] = useState(initialView);
  const [gaps, setGaps] = useState(null);

  useEffect(() => {
    // Counted up front so the tab can carry the number. A tab reading
    // "Untracked" says nothing; "Untracked 161" is the whole point.
    apiFetch("/api/statute-gaps")
      .then(d => {
        const c = d.counts || {};
        setGaps((c.needs_state || 0) + (c.needs_both || 0) + (c.needs_date || 0));
      })
      .catch(() => setGaps(null));
  }, []);

  const tab = (id, label, count) => {
    const active = view === id;
    return React.createElement("button", {
      key: id,
      onClick: () => setView(id),
      style: {
        padding: "10px 18px", border: "none", background: "transparent",
        borderBottom: active ? `2px solid ${C.gold}` : "2px solid transparent",
        color: active ? C.navy : C.textMuted,
        fontSize: "13px", fontWeight: active ? 700 : 500,
        cursor: "pointer", marginBottom: "-1px",
      },
    }, count == null ? label : `${label} (${count})`);
  };

  return React.createElement("div", null,
    React.createElement("div", {
      className: "tab-bar",
      style: {
        display: "flex", gap: "4px", padding: "20px 40px 0",
        borderBottom: `1px solid ${C.warmGray}`,
      },
    },
      tab("upcoming", "Upcoming"),
      tab("untracked", "Not yet tracked", gaps),
    ),

    view === "upcoming"
      ? React.createElement(DeadlinesPage, { onMatterClick })
      : React.createElement(StatuteGapsPage, { onMatterClick, showNotification }),
  );
}
